export default __webpack_public_path__ + "static/media/prepared.31f36ab9.svg";